import { datadogLogs } from "@datadog/browser-logs";

/**
 * Shopify 요청·응답 모니터링 로그.
 *
 * Datadog 모니터에서 @shopify.event / @shopify.operation / @shopify.code 로 집계하므로
 * 스토어가 달라도 같은 모양으로 보낸다. datadogLogs.init 은 각 앱 main.tsx 가 수행한다.
 */
interface IShopifyUserError {
  code?: string | null;
  field?: string[] | null;
  message: string;
}

interface IShopifyGraphQLError {
  message: string;
  locations?: unknown;
  path?: unknown;
}

/** HTTP 200 응답 안에 담겨 오는 거절 사유 (재고 부족·비밀번호 불일치 등). 요청 에러로는 잡히지 않는다 */
export const logShopifyUserError = (operation: string, userErrors: IShopifyUserError[]) => {
  const [{ code, field, message }] = userErrors;

  datadogLogs.logger.error(`[SHOPIFY][${operation}] UserError`, {
    shopify: { event: "user_error", operation, code, field: field?.join(","), message },
    userErrors,
  });
};

/** 스키마·변수 불일치 등 GraphQL 레벨 에러 */
export const logShopifyGraphQLErrors = (operation: string, errors: IShopifyGraphQLError[]) => {
  errors.forEach(({ message, locations, path }) => {
    datadogLogs.logger.error(`[SHOPIFY][${operation}] GraphQL error`, {
      shopify: { event: "graphql_error", operation, message },
      location: JSON.stringify(locations),
      path: JSON.stringify(path),
    });
  });
};

/** 고객 네트워크 문제·HTTP 에러 */
export const logShopifyNetworkError = (operation: string, error: unknown) => {
  const message = error instanceof Error ? error.message : String((error as { message?: string })?.message ?? error);

  datadogLogs.logger.error(`[SHOPIFY][${operation}] Network error`, {
    shopify: { event: "network_error", operation, message },
    networkError: error,
  });
};
